import {SkinTheme, UIType} from "./@const";
import LayoutProto from "../layout/layout-proto";
import GrayPalette_GoodDay from "./classic/gray-palette";
import {ConstructorType, UIConfig} from "./@type";
import UILeft_Default from "./classic/menu/left";
import CommonPalette from "../../core/gd/skin/skin-palette/common-palette";
import PaletteProto from "../../core/gd/skin/skin-palette/palette-proto";

// const debug = "GoodDayUserInterface"
const debug = false

// This is a proto class

export class GoodDayUserInterface {


    public type             : UIType


    constructor(config:UIConfig) {

        debug && console.log("GoodDayUserInterface constructor() config=", config)

        this.type           = config.type

    }

    // Navigation Panel
    // thi son IS in use (!) gd.ui.NavigationPanelUserComponent
    get NavigationPanelUserComponent():any {
        throw new Error("#9d8d8jjjj not implemented");
    }




    // Other




    get isMinimizeMenuAllowed(): boolean {
        return true
    }

    // adiditional top panel - used in Clickup / Teams
    get TopPanel():any {
        return null
    }

    get UILeftClass():ConstructorType<any, any> {
        return UILeft_Default
    }

    get uiLeftMenuThemeClass() {
        let menuThemeClass = 'theme-'+gd.user.settings.skin.menu

        if (gd.skin.layoutTheme === 'dark') {
            menuThemeClass = "theme-dark-skin"
        }

        return menuThemeClass
    }

    get uiLeftTargetClassName() {
        return ".ui-left"
    }

    get uiLeftPopoverClassName() {
        return "ui-menu-popover"
    }

    get layoutCSSClass():string {
        throw new Error("layoutCSSClass() not implemented for type=" + this.type)
    }


    get LayoutClass():ConstructorType<LayoutProto, [type:UIType]> {
        throw new Error("layoutInstance() not implemented for type=" + this.type)
    }

    get navigationPanelMainClass():string {
        throw new Error("navigationPanelMainClass() not implemented for type=" + this.type)
    }

    get leftNavigationPanelSize(): number {
        return 0
    }

    get uiCenterLeftSpace(): number {
        return this.leftNavigationPanelSize
    }

    get navbarButtonSize() {
        return 46
    }

    // it's like left panel + padding ???
    get uiCenterLeftSideDifference(): number {
        return this.leftNavigationPanelSize
    }

    get uiCenterMainClass():string {

        return "ui-center"

    }

    get hasMenuSearch() {
        return true
    }

    // New for Different Colors.
    getCommonPalette(theme: SkinTheme): PaletteProto {

        return new CommonPalette(theme) // SkinTheme used like key for palette dictionary !!!
    }

    getGrayPalette(theme: SkinTheme): PaletteProto {

        // const theme = gd.skin.layoutTheme

        switch (theme) {

            case SkinTheme.DARK:
                // @ts-ignore
                const darkPalette  = _.get(window.gd, 'user.settings.skin.darkPalette', null);
                return new GrayPalette_GoodDay(darkPalette)

            case SkinTheme.LIGHT:
                // @ts-ignore
                const lightPalette  = _.get(window.gd, 'user.settings.skin.lightPalette', null);
                return new GrayPalette_GoodDay(lightPalette)
        }

    }

    get showUpgrade():boolean {
        return !gd.company.license.isPaid
    }


    get isLight(): boolean {
        return gd.skin.layoutTheme === SkinTheme.LIGHT
    }

    get isDark():boolean {
        return gd.skin.layoutTheme === SkinTheme.DARK
    }

    get hasContrastSettings():boolean {
        return false
    }

    get quickAddLabel(): string {
        return " Add"
    }

    get moreLabel(): string {
        return ""
    }
}
